import CanShow from "./CanShow";
import GiftProjects from "@/features/gifts/gifts/Index";
import GiftProjectForm from "@/features/gifts/gifts/Form";
import GiftOrders from "@/features/gifts/orders/pages/page";

export const giftsRoutes = [
  {
    path: "/gifting",
    element: (
      <CanShow
        page={<GiftProjects />}
        ifHas={["showGiftProject", "editGiftProject"]}
      />
    ),
  },
  {
    path: "/giftProjects/orders",
    element: (
      <CanShow
        page={<GiftOrders />}
        ifHas={["showGiftProject", "editGiftProject"]}
      />
    ),
  },
  {
    path: "/giftProjects/create",
    element: <GiftProjectForm />,
  },
  {
    path: "/giftProjects/:edit/edit",
    element: <CanShow page={<GiftProjectForm />} ifHas={["editGiftProject"]} />,
  },
  {
    path: "/giftProjects/:show",
    element: <CanShow page={<GiftProjectForm />} ifHas={["showGiftProject"]} />,
  },
];
